import { render, staticRenderFns } from "./PurchasesToolExplanation.vue?vue&type=template&id=0f9eb976&"
import script from "./PurchasesToolExplanation.vue?vue&type=script&lang=js&"
export * from "./PurchasesToolExplanation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports